import { fileManagerRoutes } from './file_manager_routes';
import { trainingRoutes } from '@/routes/training_routes.js';

export const routes = [
  {
    name: 'root',
    path: '/',
    component: () => import('@/components/HelloWorld.vue'),
  },
  ...fileManagerRoutes,
  ...trainingRoutes,
];

export { fileManagerPublicRoutes } from './file_manager_routes';
